export default {
  getChecklistItemTransaction: (state) => state.checklistItemTransaction,
};
